/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable import/no-named-as-default */
import { UserManager } from 'oidc-client';
import { redirectUri, silentRedirectUri } from '../../config/routes';
import getSettings from './getSettings';

let storedUserManager = null;

/**
 * Store the user manager and return it
 * @param {UserManager} userManager
 * @returns {UserManager}
 */
const storeUserManagerAndReturn = (userManager) => {
  storedUserManager = userManager;
  return userManager;
};

/**
 * Get the userManager
 * @returns {Promise<UserManager>}
 */
export const getUserManager = () => {
  if (storedUserManager) {
    return Promise.resolve(storedUserManager);
  }

  return getSettings().then((settings) =>
    storeUserManagerAndReturn(
      new UserManager({
        authority: settings.oidc_authority,
        client_id: settings.oidc_client_id,
        redirect_uri: redirectUri,
        silent_redirect_uri: silentRedirectUri,
      })
    )
  );
};

// Export userManager
export default getUserManager;